import { useEffect, useState } from "react";

const TOUR_KEYS = {
  dashboard: "seenTour:dashboard",
  patients: "seenTour:patients",
  treatmentPlans: "seenTour:plans",
};

export const useTour = (key) => {
  const [shouldRun, setShouldRun] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem(TOUR_KEYS[key]);
    if (!seen) {
      setShouldRun(true);
    }
  }, [key]);

  const markAsSeen = () => {
    localStorage.setItem(TOUR_KEYS[key], "true");
    setShouldRun(false);
  };

  return { shouldRun, markAsSeen };
};
